// extracted by mini-css-extract-plugin
export default {"link":"bWtdXu","image":"xG6Gwj","root":"LE0APo"};